import React from 'react';

// RoofBeam brand mark — red rounded tile, white roofline, black lightning bolt.
// Coordinates authored on a 40x40 grid and scaled via viewBox, so passing a
// `size` prop scales the whole mark (and stroke widths) proportionally.
export default function RoofBeamLogo({ size = 40, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="RoofBeam"
      style={{ display: 'block', flexShrink: 0, ...style }}
    >
      <rect x="0" y="0" width="40" height="40" rx="8.8" fill="#E4322B" />
      <path
        d="M9 30 L20 18 L31 30"
        stroke="#ffffff"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M23 14 L18 23 L22 23 L19 32 L27 21 L23 21 Z" fill="#1a1a1a" />
    </svg>
  );
}

// Tile + wordmark. "Roof" color is a prop (default white for dark backgrounds;
// pass roofColor="#1a1a1a" or similar on light backgrounds). "Beam" is always
// the brand red. No "by KLO Roofing" — RoofBeam stands alone.
export function RoofBeamWordmark({ size = 40, roofColor = '#ffffff', style }) {
  const fontSize = size * 0.62;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: size * 0.28, lineHeight: 1, ...style }}>
      <RoofBeamLogo size={size} />
      <span style={{ fontWeight: 800, fontSize, letterSpacing: '-0.02em', whiteSpace: 'nowrap' }}>
        <span style={{ color: roofColor }}>Roof</span>
        <span style={{ color: '#E4322B' }}>Beam</span>
      </span>
    </span>
  );
}
